import {
  collection,
  addDoc,
  updateDoc,
  deleteDoc,
  doc,
  getDocs,
  getDoc,
  query,
  orderBy,
  onSnapshot,
} from 'firebase/firestore';
import { db } from './config';

const COLLECTION_NAME = 'branches';

// Get all branches
export const getBranches = async () => {
  try {
    const q = query(collection(db, COLLECTION_NAME), orderBy('createdAt', 'asc'));
    const snapshot = await getDocs(q);
    const branches = [];
    snapshot.forEach((d) => branches.push({ id: d.id, ...d.data() }));
    return { success: true, data: branches };
  } catch (error) {
    return { success: false, error: error.message };
  }
};

// Real-time listener
export const subscribeToBranches = (callback) => {
  const q = query(collection(db, COLLECTION_NAME), orderBy('createdAt', 'asc'));
  return onSnapshot(q, (snapshot) => {
    const branches = [];
    snapshot.forEach((d) => branches.push({ id: d.id, ...d.data() }));
    callback(branches);
  });
};

// Get single branch
export const getBranch = async (id) => {
  try {
    const snap = await getDoc(doc(db, COLLECTION_NAME, id));
    if (snap.exists()) return { success: true, data: { id: snap.id, ...snap.data() } };
    return { success: false, error: 'Branch not found' };
  } catch (error) {
    return { success: false, error: error.message };
  }
};

// Add branch
export const addBranch = async (branchData) => {
  try {
    const docRef = await addDoc(collection(db, COLLECTION_NAME), {
      name: branchData.name,
      address: branchData.address || '',
      phone: branchData.phone || '',
      managerName: branchData.managerName || '',
      status: 'active',
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    });
    return { success: true, id: docRef.id };
  } catch (error) {
    return { success: false, error: error.message };
  }
};

// Update branch
export const updateBranch = async (id, data) => {
  try {
    await updateDoc(doc(db, COLLECTION_NAME, id), {
      ...data,
      updatedAt: new Date().toISOString(),
    });
    return { success: true };
  } catch (error) {
    return { success: false, error: error.message };
  }
};

// Delete branch
export const deleteBranch = async (id) => {
  try {
    await deleteDoc(doc(db, COLLECTION_NAME, id));
    return { success: true };
  } catch (error) {
    return { success: false, error: error.message };
  }
};
